export const MESH_ACCEPT_RATIO = 66 / 142;
export const HTML_CANVAS_HEIGHT = 952;
export const HTML_CANVAS_WIDTH = HTML_CANVAS_HEIGHT * MESH_ACCEPT_RATIO;

export default {
  MESH_ACCEPT_RATIO,
  HTML_CANVAS_HEIGHT,
  HTML_CANVAS_WIDTH,
};
